import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { ReactComponent as ArrowRight } from "./arrow-right.svg";
import { ReactComponent as GrasslandsPropertyIcon } from "./grasslands-property.svg";
import { ReactComponent as HeLogo } from "../../assets/logo_he.svg";
import { ReactComponent as EnLogo } from "../../assets/logo_en.svg";
import { ContactUsModal } from "../ContactUs/ContactUsModal";
import { ContactUsSuccessModal } from "../ContactUs/ContactUsSuccessModal";
import { useFooterStyles } from "./Footer.styles";

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const [openForm, setOpenForm] = React.useState(false);
  const [openSuccess, setOpenSuccess] = React.useState(false);

  const dir = t("css.side") as "rtl" | "ltr";
  const classes = useFooterStyles();

  return (
    <>
      <div className={classes.shell}>
        <footer className={classes.root} style={{ direction: dir }}>
          <div className={classes.main}>
            <div className={classes.brandLogo}>
              {t("graphql.languageCode") === "en" ? (
                <EnLogo width={96} height={86} />
              ) : (
                <HeLogo width={96} height={86} />
              )}
            </div>

            <nav
              className={classes.group}
              aria-label={t("footer.sharonFarms")}
            >
              <span className={classes.title}>
                {t("footer.sharonFarms")}
              </span>

              <div className={classes.links}>
                <Link to="/our-story" className={classes.link}>
                  {t("footer.ourStory")}
                </Link>
              </div>
            </nav>

            <nav className={classes.group} aria-label={t("footer.legal")}>
              <span className={classes.title}>{t("footer.legal")}</span>

              <div className={classes.links}>
                <Link to="/privacy-policy" className={classes.link}>
                  {t("footer.privacyPolicy")}
                </Link>

                <Link to="/terms" className={classes.link}>
                  {t("footer.termsAndConditions")}
                </Link>
              </div>
            </nav>

            <div className={`${classes.group} ${classes.help}`}>
              <span className={classes.title}>{t("footer.Need Help")}</span>

              <button
                className={classes.customerCareLink}
                onClick={() => setOpenForm(true)}
              >
                <span>{t("footer.visitCustomerCare")}</span>
                <ArrowRight />
              </button>

              <div
                className={classes.socials}
                aria-label={t("footer.socialLinks")}
              >
                <button
                  className={classes.socialLink}
                  type="button"
                  aria-label="Facebook"
                >
                  f
                </button>
                <button
                  className={classes.socialLink}
                  type="button"
                  aria-label="Twitter"
                >
                  t
                </button>
                <button
                  className={classes.socialLink}
                  type="button"
                  aria-label="Instagram"
                >
                  ◎
                </button>
              </div>
            </div>
          </div>

          <div className={classes.divider} />

          <div className={classes.bottom}>
            <span className={classes.mutedText}>{t("footer.copyright")}</span>

            <div className={classes.property}>
              <span className={classes.propertyLabel}>
                {t("footer.grasslandsProperty")}
              </span>
              <div
                className={classes.grasslandsLockup}
                aria-label="Grasslands"
              >
                <GrasslandsPropertyIcon aria-hidden="true" focusable="false" />
                <span className={classes.grasslandsName}>Grasslands</span>
              </div>
            </div>
          </div>
        </footer>
      </div>
      <ContactUsModal
        open={openForm}
        onClose={() => setOpenForm(false)}
        onSuccess={() => setOpenSuccess(true)}
      />

      <ContactUsSuccessModal
        open={openSuccess}
        onClose={() => setOpenSuccess(false)}
      />
    </>
  );
};

export default Footer;
